module.exports = __webpack_public_path__ + "img/menuIcon27.2afd1c57.png";